import { ReactNode, useSyncExternalStore, useDeferredValue } from 'react';

interface Props {
    children: ReactNode;
}

// https://kurtextrem.de/posts/react-uses-hydration
export function useIsClient() {
    return useDeferredValue(
        useSyncExternalStore(
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            () => () => {},
            () => true,
            () => false
        )
    );
}

// ClientOnly component is used to render the children only on the client side.
// Read more about it here: https://www.joshwcomeau.com/react/the-perils-of-rehydration/
export default function ClientOnly({ children, ...delegated }: Props) {
    const isClient = useIsClient();

    if (!isClient) {
        return null;
    }

    return <section {...delegated}>{children}</section>;
}
